import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../services/apis";
import _ from "lodash";

export const fetchCollectionReport = createAsyncThunk(
    "collectionReport/fetch",
    async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
        try {
            let url = "/sales/get-sales-record";

            if (selectedRecordType === "with item") {
                url = "/sales/get-sales-record-with-details";
            }

            if (["By Item", "By Group", "By Category"].includes(selectedFilterType)) {
                url = "/sales/get-sales-details";
            }

            const payload = {
                selectedFilterType: selectedFilterType || null,
                // selectedRecordType: selectedRecordType || null,
                locationId: selectedFilterType === "By Location" ? filters.locationId : null,
                customerId: selectedFilterType === "By Customer" ? filters.customerId : null,
                employeeId: selectedFilterType === "By Employee" ? filters.employeeId : null,
                itemId: selectedFilterType === "By Item" ? filters.itemId : null,
                groupId: selectedFilterType === "By Group" ? filters.groupId : null,
                categoryId: selectedFilterType === "By Category" ? filters.categoryId : null,
                userId: selectedFilterType === "By User" ? filters.userId : null,
                fromDate: filters.fromDate,
                toDate: filters.toDate,
            };

            const [salesRes, receiptsRes] = await Promise.all([
                postData(url, payload),
                postData("/accounts/get-debitor-rcv-with-details", {
                    fromDate: filters.fromDate,
                    toDate: filters.toDate,
                })
            ]);

            let salesData = salesRes.data || [];
            let receiptsData = receiptsRes.data || [];

            // Process sales data based on record type
            let processedSales = [];
            let details = [];
            let groupWiseItems = [];
            let categoryWiseItems = [];

            if (selectedRecordType === "with item" && !["By Item", "By Group", "By Category"].includes(selectedFilterType)) {
                processedSales = salesData.map((master) => {
                    const itemCartData = master.details.map((item) => ({
                        ...item,
                        serials: item.is_serial === "yes" ? item.serials.split(",").map(slNo => ({ serial_number: slNo })) : [],
                        qty_display: `${item.item_qty} ${item.unit_symbol}${item.conversion > 1 ? `, ${item.retail_qty} ${item.base_unit_name}` : ""}`,
                    }));

                    return { ...master, details: itemCartData };
                });
            }
            else if (["By Item", "By Group", "By Category"].includes(selectedFilterType)) {
                details = salesData.map((item) => ({
                    ...item,
                    serials: item.is_serial === "yes" ? item.serials.split(",").map(slNo => ({ serial_number: slNo })) : [],
                    qty_display: `${item.item_qty} ${item.unit_symbol}${item.conversion > 1 ? `, ${item.retail_qty} ${item.base_unit_name}` : ""}`,
                }));

                // Process group-wise items
                if (selectedFilterType === "By Group") {
                    groupWiseItems = _.chain(details)
                        .groupBy("group_id")
                        .map((items) => ({
                            group_name: items[0].group_name,
                            items: _.chain(items)
                                .groupBy("item_id")
                                .map((itemGroup) => ({
                                    item_code: itemGroup[0].item_code,
                                    item_name: itemGroup[0].item_name,
                                    serials: _.flatten(_.map(itemGroup, "serials")),
                                    is_serial: itemGroup[0].is_serial,
                                    base_unit_name: itemGroup[0].base_unit_name,
                                    unit_symbol: itemGroup[0].unit_symbol,
                                    item_qty: _.sumBy(itemGroup, (item) => Number(item.item_qty)),
                                    retail_qty: _.sumBy(itemGroup, (item) => Number(item.retail_qty)),
                                    item_total: _.sumBy(itemGroup, (item) => Number(item.item_total)),
                                }))
                                .value(),
                        }))
                        .value();
                }

                // Process category-wise items
                if (selectedFilterType === "By Category") {
                    categoryWiseItems = _.chain(details)
                        .groupBy("category_id")
                        .map((items) => ({
                            category_name: items[0].category_name,
                            items: _.chain(items)
                                .groupBy("item_id")
                                .map((itemGroup) => ({
                                    item_code: itemGroup[0].item_code,
                                    item_name: itemGroup[0].item_name,
                                    serials: _.flatten(_.map(itemGroup, "serials")),
                                    is_serial: itemGroup[0].is_serial,
                                    base_unit_name: itemGroup[0].base_unit_name,
                                    unit_symbol: itemGroup[0].unit_symbol,
                                    item_qty: _.sumBy(itemGroup, (item) => Number(item.item_qty)),
                                    retail_qty: _.sumBy(itemGroup, (item) => Number(item.retail_qty)),
                                    item_total: _.sumBy(itemGroup, (item) => Number(item.item_total)),
                                }))
                                .value(),
                        }))
                        .value();
                }
            } else {
                processedSales = salesData;
            }

            return {
                sales: processedSales,
                details,
                groupWiseItems,
                categoryWiseItems,
                receipts: receiptsData,
            };
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);